import * as React from 'react';
import clsx from 'clsx';
import styled from 'styled-components';
import { IconButton } from '../IconButton';
import { IEditableListElementProps } from './EditableListElement.types';
import {
  handleOnDelete,
  handleOnTextChange,
  handleOnKeyDown,
  onTextChangeSubmit,
  useFocus
} from './EditableListElement.logic';
// @ts-ignore
import editIcon from '../../assets/icons/edit-inline.svg';
// @ts-ignore
import editIconActive from '../../assets/icons/edit-inline-active.svg';
// @ts-ignore
import deleteIcon from '../../assets/icons/delete.svg';
import { InputNone } from '../Input/Input';

const EditableListEl = styled(InputNone)<{ error: boolean }>`
  ${({ error }) =>
    error &&
    `
    border-bottom: 1px solid ${({ theme }) => theme.colors.alert};
  `};
`;

const EditIconButton = styled(IconButton)`
  cursor: pointer;
`;

const EditableListElement: React.FC<IEditableListElementProps> = (
  props: IEditableListElementProps
) => {
  const {
    className,
    removable,
    onDelete,
    text,
    disabled,
    editable,
    onTextChange,
    id
  } = props;
  const [inputRef, setInputFocus] = useFocus();

  const [state, setState] = React.useState<string>('');
  const [inputError, setInputError] = React.useState<boolean>(false);
  const [editMode, setEditMode] = React.useState<boolean>(false);

  React.useEffect(() => {
    if (editable) {
      setState(text);
    }
  }, []);

  React.useEffect(() => {
    if (editMode) {
      // @ts-ignore
      setInputFocus();
    }
  }, [editMode]);

  return (
    <div className={className}>
      <div className="inline-flex-container justify-content-space-between align-center w-100p h-100p">
        {!editable ? (
          <div className="text-medium">{text}</div>
        ) : (
          <>
            <EditableListEl
              error={inputError}
              id={`${id}-input`}
              disabled={!editMode}
              ref={inputRef}
              onKeyDown={e => handleOnKeyDown(e, state, onTextChange)}
              value={state}
              onBlur={() => {
                if (editMode && !inputError) {
                  onTextChangeSubmit(state, onTextChange);
                }

                if (inputError) {
                  handleOnTextChange(text, setState, setInputError);
                }

                setEditMode(!editMode);
              }}
              onChange={event =>
                handleOnTextChange(event.target.value, setState, setInputError)
              }
            />
            <EditIconButton
              id={`${id}-edit-button`}
              icon={editMode ? editIconActive : editIcon}
              className={clsx(['m-r-6'])}
              type="button"
              tooltipId="modalTooltip"
              tooltipText="Edit"
              onClick={() => {
                if (editMode) {
                  onTextChangeSubmit(state, onTextChange);
                }
                setEditMode(!editMode);
              }}
            />
          </>
        )}
        {removable ? (
          <IconButton
            id={`${id}-remove-button`}
            icon={deleteIcon}
            type="button"
            tooltipId="modalTooltip"
            tooltipText="Delete"
            onClick={() => handleOnDelete(disabled, onDelete)}
          />
        ) : null}
      </div>
    </div>
  );
};

export default EditableListElement;
